import Vue from 'vue';
import VueRouter from 'vue-router';

import Home from './views/Home';
import ResetPassword from './views/ResetPassword';

const createRouter = () => {
  if (process.env.NODE_ENV !== 'test') {
    Vue.use(VueRouter);
  }
  return new VueRouter({
    routes: [
      { path: '/couple-eherkenning', name: 'Home', component: Home, props: true },
      { path: '/couple-eherkenning/reset-password', name: 'ResetPassword', component: ResetPassword, props: true },
      { path: '*', redirect: '/couple-eherkenning' },
    ],
  });
};

export default createRouter;
